export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers
    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        iddocument: '',
        idprocesstype: '',
        idlawyer: '',
        date_document: getCurrentDate(),
        observations: ''
    }
    
    const defaultFormStamps = {
        iddocumentstamps: '',
        iddocument: '',
        idstamp: '',
        quantity: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen,
        defaultFormStamps
    })
}